import { Dispatch, SetStateAction, useEffect, useRef } from 'react';
import { ButtonColor, ButtonGroup, ButtonVariant, Icon, TextArea, TextButton } from '../../components';
import { KNOWLEDGE_HUB_TYPE_CONFIG } from '../../constants';
import { ComponentSize, KnowledgeHubRecordType } from '../../types';

const KNOWLEDGE_HUB_FIELD_MIN_ROWS = 1;

interface KnowledgeHubFieldProps {
  isLoading: boolean;
  type: KnowledgeHubRecordType;
  value: string;
  handleCancel: () => void;
  handleSave: () => void;
  setValue: Dispatch<SetStateAction<string>>;
}

const KnowledgeHubField = ({ isLoading, type, value, handleCancel, handleSave, setValue }: KnowledgeHubFieldProps) => {
  const textAreaRef = useRef<HTMLTextAreaElement>(null);

  // Focus the text area when the component mounts.
  useEffect(() => {
    if (textAreaRef.current) {
      textAreaRef.current.focus();
    }
  }, []);

  return (
    <TextArea
      ref={textAreaRef}
      rows={KNOWLEDGE_HUB_FIELD_MIN_ROWS}
      fitContent
      placeholder={KNOWLEDGE_HUB_TYPE_CONFIG[type].placeholder}
      value={value}
      onChange={(e) => setValue(e.target.value)}
      onKeyDown={(e) => {
        if (e.key === 'Enter') {
          e.preventDefault(); // Prevent the default behavior of the enter key.
          handleSave();
        }
      }}
      endElement={
        <ButtonGroup size={ComponentSize.X_SMALL} loading={isLoading}>
          <TextButton
            disabled={!value.trim()}
            text="Save"
            startIcon={Icon.CIRCLE_CHECK}
            variant={ButtonVariant.GHOST}
            onClick={handleSave}
          />
          <TextButton
            text="Cancel"
            color={ButtonColor.DESTRUCTIVE}
            startIcon={Icon.CIRCLE_X}
            variant={ButtonVariant.GHOST}
            onClick={handleCancel}
          />
        </ButtonGroup>
      }
    />
  );
};

export default KnowledgeHubField;
